<template>
  <a-tabs default-active-key="1">
    <a-tab-pane key="1">
          <span slot="tab">
            <a-icon type="dollar"/>
              Gastos
          </span>
      <a-row v-if="isAdmin">
        <contract-person @contractSelected="contractSelected"/>
      </a-row>
      <a-spin :spinning="spinning">
        <a-row v-if="!isAdmin">
          <a-col :span="12" :offset="6">
            <a-card>
              <span slot="title">
                <a-icon type="dollar"/>
                Gastos
              </span>
              <a-form-model layout="horizontal" :model="iForm" :rules="formRules"
                            @submit.native.prevent @submit="guardar"
                            v-bind="fiOptions"
                            ref="form">
                <a-form-model-item prop="living_place" :label="$t('Vivienda')">
                  <a-input-number style="width: 100%" step="1"
                                  v-model="iForm.living_place"
                                  :default-value="0"
                  >
                  </a-input-number>
                </a-form-model-item>

                <a-form-model-item prop="education"  :label="$t('Educación')">
                  <a-input-number style="width: 100%" step="1"
                                  v-model="iForm.education"
                                  :default-value="0"
                  >
                  </a-input-number>
                </a-form-model-item>

                <a-form-model-item prop="feeding"  :label="$t('Alimentación')">
                  <a-input-number style="width: 100%" step="1"
                                  v-model="iForm.feeding"
                                  :default-value="0"
                  >
                  </a-input-number>
                </a-form-model-item>

                <a-form-model-item prop="clothing" :label="$t('Vestimenta')">
                  <a-input-number style="width: 100%" step="1"
                                  v-model="iForm.clothing"
                                  :default-value="0"
                  >
                  </a-input-number>
                </a-form-model-item>

                <a-form-model-item prop="health" :label="$t('Salud')">
                  <a-input-number style="width: 100%" step="1"
                                  v-model="iForm.health"
                                  :default-value="0"
                  >
                  </a-input-number>
                </a-form-model-item>

                <a-form-model-item prop="concept" :label="$t('Concepto discapacidad')">
                  <a-input-number style="width: 100%" step="1"
                                  v-model="iForm.concept"
                                  :default-value="0"
                  >
                  </a-input-number>
                </a-form-model-item>

                <a-form-model-item :label="$t('Total gastos')">
                  <strong>
                    {{getTotal}}
                  </strong>
                </a-form-model-item>
                  <a-form-model-item>
                    <a-button
                      style="float: right;"
                      type="primary"
                      html-type="submit">
                      Guardar Gastos
                    </a-button>
                  </a-form-model-item>
                </a-form-model>
            </a-card>
          </a-col>
        </a-row>
        <a-row v-else>
          <a-col :span="12" :offset="6">
            <br>
            <a-card hoverable>
              <span slot="title">
                <a-icon type="dollar"/>
                Gastos
              </span>
              <a-descriptions  v-if="idEmp" :column="{ md: 1, sm: 1, xs: 1 }"
                               bordered
                               size="small">
                <a-descriptions-item :label="$t('Vivienda')">
                  {{iForm.living_place}}
                </a-descriptions-item>

                <a-descriptions-item :label="$t('Educación arte y cultura')">
                  {{iForm.education}}
                </a-descriptions-item>

                <a-descriptions-item :label="$t('Alimentación')">
                  {{iForm.feeding}}
                </a-descriptions-item>

                <a-descriptions-item :label="$t('Vestimenta')">
                  {{iForm.clothing}}
                </a-descriptions-item>

                <a-descriptions-item :label="$t('Salud')">
                  {{iForm.health}}
                </a-descriptions-item>

                <a-descriptions-item :label="$t('Concepto de discapacidad')">
                  {{iForm.concept}}
                </a-descriptions-item>

                <a-descriptions-item :label="$t('Total de gastos')">
                  <strong>
                    {{getTotal}}
                  </strong>
                </a-descriptions-item>
              </a-descriptions>
              <span v-else>Seleccione un contrato para visualizar los gastos.</span>
            </a-card>
          </a-col>
        </a-row>

      </a-spin>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      if (this.$store.state.userInfo.id_emp != -1) {
        this.idEmp = this.$store.state.userInfo.id_emp
        this.getData()
      }
    },
    data () {
      return {
        spinning: false,
        idEmp: null,
        iForm: {},
        formRules: {},
        colSpan: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 15},
          'has-feedback': true,
          'labelAlign': 'left'
        }
      }
    },
    methods: {
      getData () {
        this.spinning = true
        this.httpClient.getInstance().get('expense', {params: {id_emp: this.idEmp}}).then(response => {
          if (this.$isEmpty(response.data)) {
            this.iForm = {
              living_place: 0,
              education: 0,
              feeding: 0,
              clothing: 0,
              health: 0,
              concept: 0,
              id_emp: this.idEmp
            }
          } else {
            this.iForm = response.data
          }
        }).catch(error => {
          Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible consultar la información, contacte al administrador.'))
        }).then(() => {
          this.spinning = false
        })
      },
      guardar () {
        this.spinning = true
        this.httpClient.getInstance().post('expense', this.iForm)
          .then(() => {
            Mensajes.success('Correcto', 'Datos guardados correctamente')
          })
          .catch(error => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible guardar la información, contacte al administrador.'))
          }).then(() => {
            this.spinning = false
          })
      },
      contractSelected (idEmp) {
        this.idEmp = idEmp
      },
      toNumber (val) {
        if (this.$isEmpty(val)) {
          return 0
        }
        return parseFloat(val)
      }
    },
    computed: {
      getTotal () {
        return this.toNumber(this.iForm.living_place) +
          this.toNumber(this.iForm.education) +
          this.toNumber(this.iForm.feeding) + this.toNumber(this.iForm.clothing) +
          this.toNumber(this.iForm.health) + this.toNumber(this.iForm.concept)
      },
      isAdmin () {
        return this.$userIsInrol('Management')
      }
    },
    watch: {
      idEmp () {
        this.getData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/Atributos.vue